// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import Criteria from '../../state/criteria';
import DealerHierarchyTerritory from '@deere/cps-it.warranty-model-factory/lib/dealer-hierarchy-territory';
import OriginalSubmissionDateCriteria from './date-criteria';
import TerritoryCriteria from './territory-criteria';

const SpecialAllowanceClaimStatusInputCriteria = props =>
    <div className='special-allowance-claim-status-input-criteria'>
        <div className='row'>
            <TerritoryCriteria
                allowedTerritories={props.allowedTerritories}
                handleSelectAllTerritories={props.handleSelectAllTerritories}
                handleTerritorySelect={props.handleTerritorySelect}
                selectedTerritories={props.criteria.selectedTerritories}
            />
            <OriginalSubmissionDateCriteria
                dateRange={props.criteria.originalSubmissionDate}
                label='ORIGINAL_SUBMISSION_DATE'
                onDateChange={props.handleOriginalSubmissionDateSelect}
            />
        </div>
    </div>;

SpecialAllowanceClaimStatusInputCriteria.displayName = 'SpecialAllowanceClaimStatusInputCriteria';
SpecialAllowanceClaimStatusInputCriteria.propTypes = {
    allowedTerritories: PropTypes.arrayOf(PropTypes.instanceOf(DealerHierarchyTerritory)).isRequired,
    criteria: PropTypes.instanceOf(Criteria).isRequired,
    handleOriginalSubmissionDateSelect: PropTypes.func.isRequired,
    handleSelectAllTerritories: PropTypes.func.isRequired,
    handleTerritorySelect: PropTypes.func.isRequired
};

export default SpecialAllowanceClaimStatusInputCriteria;



// WEBPACK FOOTER //
// ./src/reports/special-allowance-claim-status/components/special-allowance-claim-status-report-criteria/input-criteria.js